/*
 *
 * RubiconePopup
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 04-Feb-2025
 */

import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux'
import RubiconePopup from './RubiconePopup'
import { nullSafe } from 'Utility/globalMethods'
import { doHidePopup } from 'Store/actions/popup'

const mapDispatchToProps = (dispatch) => ({
  doHidePopup: () => dispatch(doHidePopup())
})

const mapStateToProps = (state) => ({
  infoPage: state.RubiconeGold.switchConvoInfo,
  shops: state.RubiconeGold.shops,
  selectedShop: nullSafe(() => state.popup.popupInfo.store, {}),
  hashedMerchantId: nullSafe(() => state.userProfiling.hashedMerchantId, '')
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(RubiconePopup)
